import { createFundsStore } from 'features/Funds/infra/react/Funds.state'
import { getFundsInfo } from 'features/Funds/infra/remote/getFundsInfo'
import { ErrorLib } from 'libs/errors'

export const fundsStore = createFundsStore({
  getFundsInfo: ErrorLib.wrapReportOnReject(getFundsInfo),
})
